import React, { useState } from 'react'
import {
  SESSION_STATUS_GLOSSARY,
  LOGOUT_LOGIC_GLOSSARY,
} from '../constants/sessionGlossary'

export default function PersistentStatusLegendBar({ onOpenFullModal }) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="mb-4 rounded-2xl border border-outline-variant/25 bg-surface-container-low/70 p-3.5 sm:p-4 transition-all">
      {/* Top summary row */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <span className="flex h-7 w-7 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-base">help</span>
          </span>
          <div>
            <span className="text-xs font-black uppercase tracking-wider text-on-surface">
              Status & Meaning Guide
            </span>
            <span className="hidden sm:inline text-xs text-on-surface-variant font-medium ml-2">
              — Quick reference for session validation & logout categories
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 ml-auto">
          <button
            type="button"
            onClick={onOpenFullModal}
            className="inline-flex items-center gap-1.5 rounded-xl border border-outline-variant/30 bg-surface-container-lowest px-3 py-1 text-xs font-bold text-primary hover:bg-surface-container transition"
          >
            <span className="material-symbols-outlined text-sm">open_in_new</span>
            <span>All Definitions</span>
          </button>
          {/* <button
            type="button"
            onClick={() => setIsExpanded(!isExpanded)}
            className="inline-flex items-center gap-1 rounded-xl bg-surface-container px-2.5 py-1 text-xs font-bold text-on-surface-variant hover:text-on-surface hover:bg-surface-container-high transition"
            aria-label={isExpanded ? 'Collapse legend' : 'Expand legend'}
          >
            <span>{isExpanded ? 'Hide' : 'Quick View'}</span>
            <span
              className="material-symbols-outlined text-sm transition-transform duration-200"
              style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
            >
              expand_more
            </span>
          </button> */}
        </div>
      </div>

      {/* Expandable Quick Reference Grid */}
      {isExpanded && (
        <div className="mt-3.5 pt-3.5 border-t border-outline-variant/15 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-xs animate-in fade-in duration-200">
          {/* LIVE */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-primary uppercase text-[11px] tracking-wider">
              <span className="h-2 w-2 rounded-full bg-primary" />
              LIVE
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {SESSION_STATUS_GLOSSARY.LIVE.meaning}
            </p>
          </div>

          {/* VALIDATED */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-emerald-700 uppercase text-[11px] tracking-wider">
              <span className="h-2 w-2 rounded-full bg-emerald-500" />
              VALIDATED
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {SESSION_STATUS_GLOSSARY.VALIDATED.meaning}
            </p>
          </div>

          {/* RECOVERED */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-amber-600 uppercase text-[11px] tracking-wider">
              <span className="h-2 w-2 rounded-full bg-amber-500" />
              RECOVERED
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {SESSION_STATUS_GLOSSARY.RECOVERED.meaning}
            </p>
          </div>

          {/* MISSING */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-error uppercase text-[11px] tracking-wider">
              <span className="h-2 w-2 rounded-full bg-error" />
              MISSING (LOGOUT)
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {SESSION_STATUS_GLOSSARY.MISSING.meaning}
            </p>
          </div>

          {/* ACTIVE SESSION */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-emerald-800 uppercase text-[11px] tracking-wider">
              <span className="material-symbols-outlined text-xs">bolt</span>
              Active Session
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {LOGOUT_LOGIC_GLOSSARY.ACTIVE_SESSION.meaning}
            </p>
          </div>

          {/* USER INACTIVE */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-rose-800 uppercase text-[11px] tracking-wider">
              <span className="material-symbols-outlined text-xs">timer_off</span>
              User Inactive
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {LOGOUT_LOGIC_GLOSSARY.USER_INACTIVE.meaning}
            </p>
          </div>

          {/* SYSTEM FAILURE */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-error uppercase text-[11px] tracking-wider">
              <span className="material-symbols-outlined text-xs">error</span>
              System Failure
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {LOGOUT_LOGIC_GLOSSARY.SYSTEM_FAILURE.meaning}
            </p>
          </div>

          {/* END OF SHIFT */}
          <div className="rounded-xl bg-surface-container-lowest p-3 border border-outline-variant/15">
            <div className="flex items-center gap-1.5 mb-1 font-bold text-indigo-800 uppercase text-[11px] tracking-wider">
              <span className="material-symbols-outlined text-xs">schedule</span>
              End Of Shift
            </div>
            <p className="text-[11px] text-on-surface-variant leading-snug">
              {LOGOUT_LOGIC_GLOSSARY.END_OF_SHIFT.meaning}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
